<div class="principal">
	<img src="../../../../assets/images/logo-load.png" alt="search" />
	<h2>Parameters</h2>
	<p>Debes seleccionar un parametro, o bien, crear uno nuevo</p>
</div>
